export default "__VITE_ASSET__BgXTgTxo__"